import React from "react";
import { Link } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineFile,
  // AiOutlineProject,
  AiOutlineMail,
  AiOutlineLink,
  AiOutlineDesktop,
  AiOutlineRead,
} from "react-icons/ai";
// import { HiOutlineBriefcase } from "react-icons/hi";

import "./Sidebar.css";

const Sidebar = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Styles for vertical scroll, bottom space, and hiding scrollbar
  const sidebarStyle = {
    overflowY: "auto",
    maxHeight: "calc(100vh - 0px)",
    paddingBottom: "80px",
    marginBottom: "80px",
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE 10+
  };

  // Hide scrollbar for Webkit browsers
  const sidebarInnerStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  };

  return (
    <div
      className="sidebar"
      style={sidebarStyle}
      // Hide scrollbar for Webkit browsers
    >
      <style>
        {`
          .sidebar::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
      <div style={sidebarInnerStyle}>
        <div className="sidebar-title">
          <a
            href="/"
            className="sidebar-title-link sidebar-title-hover"
            style={{
              textDecoration: "none",
              paddingTop: "2%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: "16px",
              marginTop: "12px",
              gap: "8px",
            }}
          >
            {/* <h2 className="sidebardTitle">Danial's website</h2> */}
            {/* <h2 className="sidebardTitle">ダニアル・コア</h2> */}
            <img
              src="/Gemini_Generated_Image_mnryikmnryikmnry-removebg-preview-1.png"
              // src="/The Guardian.png"
              alt="Guardian Icon"
              className="sidebar-title-img"
              style={{
                height: "240px",
                transition: "transform 0.3s cubic-bezier(0.4,0,0.2,1)",
                filter:
                  "brightness(0) invert(1) sepia(1) saturate(0) hue-rotate(0deg) brightness(0.8) contrast(1)",
                WebkitFilter:
                  "brightness(0) invert(1) sepia(1) saturate(0) hue-rotate(0deg) brightness(0.8) contrast(1)",
                transitionProperty: "filter, -webkit-filter, transform",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.filter =
                  "brightness(1) invert(1) sepia(1) saturate(0) hue-rotate(0deg) brightness(0.95) contrast(1)";
                e.currentTarget.style.WebkitFilter =
                  "brightness(1) invert(1) sepia(1) saturate(0) hue-rotate(0deg) brightness(0.95) contrast(1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.filter =
                  "brightness(0) invert(1) sepia(1) saturate(0) hue-rotate(0deg) brightness(0.8) contrast(1)";
                e.currentTarget.style.WebkitFilter =
                  "brightness(0) invert(1) sepia(1) saturate(0) hue-rotate(0deg) brightness(0.8) contrast(1)";
              }}
            />
            {/* <h2
              className="sidebardTitle"
              style={{ transition: "color 0.3s cubic-bezier(0.4,0,0.2,1)" }}
            >
              𐎠𐏃𐎢𐎼𐎶
            </h2> */}
          </a>
        </div>

        <Link
          to="/"
          className="sidebar-link"
          title="Home"
          onClick={scrollToTop}
        >
          <div className="section">
            <AiOutlineHome size={20} /> Home
          </div>
        </Link>

        {/* <Link to="/about-me" className="sidebar-link" title="About Me">
          <div className="section">
            <AiOutlineUser size={20} /> About Me
          </div>
        </Link> */}

        {/* <Link
          to="/freelance"
          className="sidebar-link"
          title="Freelance Services"
          onClick={scrollToTop}
        >
          <div className="section">
            <HiOutlineBriefcase size={20} /> Freelance
          </div>
        </Link> */}

        {/* <Link
          to="/portfolio"
          className="sidebar-link"
          title="Portfolio"
          onClick={scrollToTop}
        >
          <div className="section">
            <AiOutlineProject size={20} /> Portfolio
          </div>
        </Link> */}

        {/* <Link
          to="/startups"
          className="sidebar-link"
          title="Startups"
          onClick={scrollToTop}
        >
          <div className="section">
            <AiOutlineRocket size={20} /> Startups
          </div>
        </Link> */}

        <Link
          to="/resume"
          className="sidebar-link"
          title="Resume"
          onClick={scrollToTop}
        >
          <div className="section">
            <AiOutlineFile size={20} /> Resume
          </div>
        </Link>

        <a
          href="https://ghost.danials.org/"
          className="sidebar-link"
          title="Blog"
          onClick={scrollToTop}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="section">
            <AiOutlineRead size={20} /> Blog
          </div>
        </a>

        <Link
          to="/links"
          className="sidebar-link"
          title="Links"
          onClick={scrollToTop}
        >
          <div className="section">
            <AiOutlineLink size={20} /> Links
          </div>
        </Link>

        {/* <Link to="/fractal" className="sidebar-link" title="Fractal">
          <div className="section">
            <FaCube size={20} /> Fractal
          </div>
        </Link> */}

        {/* <Link to="/travel" className="sidebar-link" title="Travel Map">
          <div className="section">
            <FaGlobeAsia size={20} /> Travel Map
          </div>
        </Link> */}

        {/* <Link to="/skills" className="sidebar-link" title="Skills">
          <div className="section">
            <AiOutlineTool size={20} /> Skills
          </div>
        </Link> */}
        <a
          href="/desktop.html"
          className="sidebar-link"
          title="Desktop"
          onClick={scrollToTop}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="section">
            <AiOutlineDesktop size={20} /> Desktop
          </div>
        </a>

        <Link
          to="/contact"
          className="sidebar-link"
          title="Contact"
          onClick={scrollToTop}
        >
          <div className="section">
            <AiOutlineMail size={20} /> Contact
          </div>
        </Link>

        {/* <Link to="/set-meeting" className="sidebar-link" title="Set Meeting">
          <div className="section">
            <AiOutlineCalendar size={20} /> Set Meeting
          </div>
        </Link> */}
      </div>
    </div>
  );
};

export default Sidebar;
